exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#tab[data-v-3a14ad6d]{padding:4px 0;width:100%;text-align:center}.count[data-v-3a14ad6d]{font-size:17px}.count[data-v-3a14ad6d],.label[data-v-3a14ad6d]{font-weight:700}", ""]);
